import React from 'react';
import { useSelector } from 'react-redux';
import { constants as appStorageConstants } from '@saucelabs/sl-module-app-storage';
import { Typography } from '@saucelabs/ds-typography';
import {
  IconIosFill,
  IconAndroidFill,
} from '@saucelabs/ds-icons';

import selectors from '../selectors';
import { FileIcon } from '../../file';

const {
  APP_STORAGE_KIND,
  APP_STORAGE_PRETTY_PLATFORM,
} = appStorageConstants;

const KindIcon = Object.freeze({
  [APP_STORAGE_KIND.IOS]: IconIosFill,
  [APP_STORAGE_KIND.ANDROID]: IconAndroidFill,
  [APP_STORAGE_KIND.OTHER]: () => (<></>),
});

const GroupSummary: React.FC = () => {
  const group = useSelector(selectors.currentGroupSelector);
  const Icon = group ? KindIcon[group.recent.kind] : null;

  return (
    <div className="p-3 border-solid border-0 border-b border-gray-200">
      <div className="flex flex-row">
        <div className="h-5 w-5 mr-2 flex-shrink-0">
          {group && (
            <FileIcon
              alt="App Group Icon"
              className="h-full w-full"
              file={group.recent}
            />
          )}

        </div>
        <div className="overflow-hidden">
          <Typography
            className="
              text-high-emphasis
              leading-6
              font-semibold
              overflow-hidden
              overflow-ellipsis"
          >
            {group?.recent.name}
          </Typography>
          <Typography
            className="
              text-medium-emphasis
              overflow-hidden
              overflow-ellipsis"
          >
            <div className="flex gap-1">
              <span>{group?.name}</span>
              <span>{group ? '|' : ''}</span>
              {Icon ? <Icon className="h-2 w-auto self-center text-medium-emphasis fill-current" /> : ''}
              {group ? ' ' : ''}
              {group ? APP_STORAGE_PRETTY_PLATFORM[group?.recent.kind] : ''}
            </div>
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default GroupSummary;
